export default "__VITE_ASSET__B_SDmj7c__"